// react
import * as React from "react";
import { motion } from "framer-motion";
import { TndevCtx } from "../../../contexts/TndevContext";
import Cookies from "js-cookie";
import {
  Link,
  Outlet,
  useNavigate,
  useLocation,
  Navigate,
  NavLink,
} from "react-router-dom";
import { useMutation } from "react-query";

// mui
import HomeIcon from "@mui/icons-material/Home";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import LocalPrintshopIcon from "@mui/icons-material/LocalPrintshop";
import InboxIcon from "@mui/icons-material/MoveToInbox";
import MailIcon from "@mui/icons-material/Mail";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import MoveDownIcon from "@mui/icons-material/MoveDown";
import BallotIcon from "@mui/icons-material/Ballot";
import TextsmsIcon from "@mui/icons-material/Textsms";
import AutoAwesomeMotionIcon from "@mui/icons-material/AutoAwesomeMotion";
import AutoAwesomeMosaicIcon from "@mui/icons-material/AutoAwesomeMosaic";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import FeaturedPlayListIcon from "@mui/icons-material/FeaturedPlayList";
import VisibilityIcon from "@mui/icons-material/Visibility";
import PropTypes from "prop-types";

//import Link from "@mui/material/Link";
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Divider from "@mui/material/Divider";
import TreeView from "@mui/lab/TreeView";
import TreeItem from "@mui/lab/TreeItem";
import Paper from "@mui/material/Paper";
import {
  Card,
  CardContent,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  ListItemButton,
  Breadcrumbs,
} from "@mui/material";
import { styled } from "@mui/material/styles";

// ch component

import Navbar from "../../../components/Navbar";
import cnss from "../../../assets/msa/cnss2.png";
import FooterDashboard from "../../../components/FooterDashboard";

const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: theme.palette.mode === "dark" ? "#1A2027" : "#fff",
  ...theme.typography.body2,
  padding: theme.spacing(1),
  textAlign: "center",
  color: theme.palette.text.secondary,
}));

export default function Steg() {
  const [methods, states] = TndevCtx();
  const { authMethods } = methods;
  const { apiLogin } = authMethods;
  const { setLoguedIn, user, setUser, lang } = states;

  let navigate = useNavigate();
  let location = useLocation();

  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <>
      <Navbar />
      <Grid container spacing={0} sx={{ mt: 10, minHeight: "100vh" }}>
        <Grid className="sidebar" item xs={2}>
          <Item sx={{ minHeight: "100vh" }}>
            <Breadcrumbs sx={{ ml: 2 }}>
              <Link
                underline="hover"
                color="inherit"
                to="/portal"
                style={{ textDecoration: "none", color: "#333" }}
              >
                البوابة
              </Link>
              <Link
                underline="hover"
                color="inherit"
                to="/material-ui/getting-started/installation/"
                style={{ textDecoration: "none", color: "#333" }}
              >
                صندوق الضمان الاجتماعي
              </Link>
            </Breadcrumbs>
            <Box>
              <List>
                <ListItem>
                  <ListItemIcon>
                    {" "}
                    <img src={cnss} alt="steg" height="53" />
                  </ListItemIcon>
                  <Typography
                    component="h2"
                    variant="h6"
                    color="primary"
                    gutterBottom
                    align={lang === "ar" ? "left" : "right"}
                  >
                    CNAM
                  </Typography>
                  <ListItemIcon>
                    {" "}
                    <HomeIcon
                      sx={{
                        display: "block",
                        fontSize: "1.8rem",
                        mt: -1,
                        cursor: "pointer",
                        mx: 3,
                      }}
                      id="basic-button"
                      aria-controls={open ? "basic-menu" : undefined}
                      aria-haspopup="true"
                      aria-expanded={open ? "true" : undefined}
                      onClick={handleClick}
                      onMouseEnter={handleClick}
                    />
                    <Menu
                      id="basic-menu"
                      anchorEl={anchorEl}
                      open={open}
                      onClose={handleClose}
                      MenuListProps={{
                        "aria-labelledby": "basic-button",
                      }}
                    >
                      <MenuItem onClick={handleClose}>
                        <NavLink
                          to="/portail"
                          style={{ textDecoration: "none" }}
                          className={({ isActive }) =>
                            isActive ? "red" : "gray"
                          }
                        >
                          <motion.span
                            style={{ display: "block" }}
                            whileHover={{
                              x: 5,
                              scale: 1.02,
                              // color: "red",
                              // transition: { ease: "easeOut", duration: 0.71 },
                            }}
                          >
                            PORTAIL
                          </motion.span>
                        </NavLink>
                      </MenuItem>
                      <MenuItem onClick={handleClose}>
                        <NavLink
                          to="/steg"
                          style={{ textDecoration: "none" }}
                          className={({ isActive }) =>
                            isActive ? "red" : "gray"
                          }
                        >
                          <motion.span
                            style={{ display: "block" }}
                            whileHover={{
                              x: 5,
                              scale: 1.02,
                              // color: "red",
                              // transition: { ease: "easeOut", duration: 0.71 },
                            }}
                          >
                            STEG
                          </motion.span>
                        </NavLink>
                      </MenuItem>
                      <MenuItem onClick={handleClose}>
                        <NavLink
                          to="/cnss"
                          style={{ textDecoration: "none" }}
                          className={({ isActive }) =>
                            isActive ? "red" : "gray"
                          }
                        >
                          <motion.span
                            style={{ display: "block" }}
                            whileHover={{
                              x: 5,
                              scale: 1.02,
                              // color: "red",
                              // transition: { ease: "easeOut", duration: 0.71 },
                            }}
                          >
                            CNSS
                          </motion.span>
                        </NavLink>
                      </MenuItem>
                    </Menu>
                  </ListItemIcon>
                </ListItem>
              </List>

              <Divider />

              <List>
                <ListItem sx={{ mb: -1, cursor: "pointer" }}>
                  <ListItemIcon>
                    <MoveDownIcon />
                  </ListItemIcon>
                  <NavLink
                    to="cnam1"
                    style={{ textDecoration: "none" }}
                    className={({ isActive }) => (isActive ? "red" : "gray")}
                  >
                    <motion.span
                      style={{ display: "block" }}
                      whileHover={{
                        x: 5,
                        scale: 1.02,
                        // color: "red",
                        // transition: { ease: "easeOut", duration: 0.71 },
                      }}
                    >
                      cnam1
                    </motion.span>
                  </NavLink>
                </ListItem>
                <ListItem sx={{ mb: -1, cursor: "pointer" }}>
                  <ListItemIcon>
                    <FeaturedPlayListIcon />
                  </ListItemIcon>
                  <NavLink
                    to="cnam2"
                    style={{ textDecoration: "none" }}
                    className={({ isActive }) => (isActive ? "red" : "gray")}
                  >
                    <motion.span
                      style={{ display: "block" }}
                      whileHover={{
                        x: 5,
                        scale: 1.02,
                        // color: "red",
                        // transition: { ease: "easeOut", duration: 0.71 },
                      }}
                    >
                      cnam1 Link2
                    </motion.span>
                  </NavLink>
                </ListItem>
                <ListItem sx={{ mb: -1, cursor: "pointer" }}>
                  <ListItemIcon>
                    <BallotIcon />
                  </ListItemIcon>
                  <NavLink
                    to="cnam3"
                    style={{ textDecoration: "none" }}
                    className={({ isActive }) => (isActive ? "red" : "gray")}
                  >
                    <motion.span
                      style={{ display: "block" }}
                      whileHover={{
                        x: 5,
                        scale: 1.02,
                        // color: "red",
                        // transition: { ease: "easeOut", duration: 0.71 },
                      }}
                    >
                      cnam Link3
                    </motion.span>
                  </NavLink>
                </ListItem>
                <ListItem sx={{ mb: -1, cursor: "pointer" }}>
                  <ListItemIcon>
                    <CalendarMonthIcon />
                  </ListItemIcon>
                  <NavLink
                    to="cnam4"
                    style={{ textDecoration: "none" }}
                    className={({ isActive }) => (isActive ? "red" : "gray")}
                  >
                    <motion.span
                      style={{ display: "block" }}
                      whileHover={{
                        x: 5,
                        scale: 1.02,
                        // color: "red",
                        // transition: { ease: "easeOut", duration: 0.71 },
                      }}
                    >
                      cnam Link4
                    </motion.span>
                  </NavLink>
                </ListItem>

                <ListItem sx={{ mb: -1, cursor: "pointer" }}>
                  <ListItemIcon>
                    <InboxIcon />
                  </ListItemIcon>
                  <NavLink
                    to="cnam5"
                    style={{ textDecoration: "none" }}
                    className={({ isActive }) => (isActive ? "red" : "gray")}
                  >
                    <motion.span
                      style={{ display: "block" }}
                      whileHover={{
                        x: 5,
                        scale: 1.02,
                        // color: "red",
                        // transition: { ease: "easeOut", duration: 0.71 },
                      }}
                    >
                      cnam Link5
                    </motion.span>
                  </NavLink>
                </ListItem>
                <ListItem sx={{ mb: -1, cursor: "pointer" }}>
                  <ListItemIcon>
                    <TextsmsIcon />
                  </ListItemIcon>
                  <NavLink
                    to="cnam6"
                    style={{ textDecoration: "none" }}
                    className={({ isActive }) => (isActive ? "red" : "gray")}
                  >
                    <motion.span
                      style={{ display: "block" }}
                      whileHover={{
                        x: 5,
                        scale: 1.02,
                        // color: "red",
                        // transition: { ease: "easeOut", duration: 0.71 },
                      }}
                    >
                      cnam Link6
                    </motion.span>
                  </NavLink>
                </ListItem>
                <ListItem sx={{ mb: -1, cursor: "pointer" }}>
                  <ListItemIcon>
                    <AutoAwesomeMosaicIcon />
                  </ListItemIcon>
                  <NavLink
                    to="cnam7"
                    style={{ textDecoration: "none" }}
                    className={({ isActive }) => (isActive ? "red" : "gray")}
                  >
                    <motion.span
                      style={{ display: "block" }}
                      whileHover={{
                        x: 5,
                        scale: 1.02,
                        // color: "red",
                        // transition: { ease: "easeOut", duration: 0.71 },
                      }}
                    >
                      cnam Link7
                    </motion.span>
                  </NavLink>
                </ListItem>
                <ListItem sx={{ mb: -1, cursor: "pointer" }}>
                  <ListItemIcon>
                    <AutoAwesomeMotionIcon />
                  </ListItemIcon>
                  <NavLink
                    to="cnam8"
                    style={{ textDecoration: "none" }}
                    className={({ isActive }) => (isActive ? "red" : "gray")}
                  >
                    <motion.span
                      style={{ display: "block" }}
                      whileHover={{
                        x: 5,
                        scale: 1.02,
                        // color: "red",
                        // transition: { ease: "easeOut", duration: 0.71 },
                      }}
                    >
                      cnam Link8
                    </motion.span>
                  </NavLink>
                </ListItem>
              </List>
            </Box>
          </Item>
        </Grid>
        <Grid className="content" item xs={10}>
          <Item sx={{ minHeight: "100vh" }}>
            {/* components steg here */}

            <Outlet />
          </Item>
          <FooterDashboard />
        </Grid>
      </Grid>
    </>
  );
}
